import { Label, Message, Select } from '@sbab-ui/components'
import { ChangeEvent } from 'react'
import { InterestRate } from '../api/httpHandlers'
import RatesOptions from './RatesOptions'

interface Props {
  value: number
  label: string
  cirkatid?: string
  selectChangeHandler: (event: ChangeEvent<HTMLSelectElement>) => void
  errorMessage?: string
  isValidHandler?: (value: number) => boolean
  options?: InterestRate[]
  wide?: boolean
  disabled?: boolean
}

function CustomSelect({
  value,
  label,
  cirkatid,
  selectChangeHandler,
  errorMessage,
  isValidHandler,
  options,
  wide,
  disabled = false,
}: Readonly<Props>) {
  const id = 'interestRateIndex'
  let hasError = false
  if (isValidHandler !== undefined) {
    hasError = !isValidHandler(value)
  }
  return (
    <div className={`mb-2 flex w-full flex-col ${wide ? '' : 'lg:mr-3 lg:max-w-[47%]'}`}>
      <Label block className="mb-1" htmlFor={id}>
        {label}
      </Label>
      <div className="self-start pb-[10px] font-medium">{cirkatid}</div>
      <Select
        data-cs-mask
        block
        id={id}
        value={value}
        data-label={id}
        onChange={selectChangeHandler}
        invalid={hasError}
        disabled={disabled}
      >
        <RatesOptions options={options as InterestRate[]} />
      </Select>

      {hasError ? (
        <Message tone="critical" className="mt-1">
          {errorMessage}
        </Message>
      ) : null}
    </div>
  )
}

export default CustomSelect
